import React, { useState } from 'react';
import '../assets/styles/modal.css';
import { db, auth } from '../firebaseConfig';
import { doc, updateDoc, setDoc, addDoc, collection } from 'firebase/firestore';
import BankVerificationSuccessModal from './BankVerificationSuccessModal';

const VerificationModal = ({ isOpen, onClose }) => {
    const [formData, setFormData] = useState({
        bankName: '',
        accountType: 'corriente',
        accountNumber: '',
        rut: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    if (!isOpen) return null;

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            if (!auth.currentUser) throw new Error("Usuario no autenticado");

            const userRef = doc(db, 'usuarios', auth.currentUser.uid);
            // 1. Guardamos la solicitud en una colección separada para el Admin
            // Usamos addDoc para crear un documento nuevo siempre y evitar problemas de permisos de sobreescritura
            const requestsCollection = collection(db, 'solicitudes_verificacion');
            await addDoc(requestsCollection, {
                uid: auth.currentUser.uid,
                email: auth.currentUser.email,
                bankAccount: formData,
                status: 'pending',
                requestDate: new Date()
            });

            // 2. Actualizamos el perfil del usuario
            await updateDoc(userRef, {
                bankAccount: formData,
                verificationStatus: 'generating_deposit',
                verificationAttempts: 0,
                verificationAmount: 0 // Reset previous amount to ensure clean slate
            });

            setShowSuccessModal(true);
        } catch (error) {
            console.error("Error al guardar datos bancarios:", error);
            alert("Error al guardar la información. Inténtalo de nuevo.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleSuccessModalClose = () => {
        setShowSuccessModal(false);
        onClose();
    };

    return (
        <>
            <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>&times;</button>

                <h2 style={{ marginBottom: '15px', textAlign: 'center' }}>Verificar Cuenta Bancaria</h2>
                <p style={{ fontSize: '0.9rem', marginBottom: '20px', textAlign: 'center', opacity: 0.8 }}>
                    Ingresa tu cuenta bancaria personal. Te enviaremos un monto aleatorio (entre $10 y $100 CLP) para verificar que te pertenece.
                </p>

                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>

                    <div className="form-group">
                        <label>Banco</label>
                        <input
                            id="verify-bank-name"
                            type="text"
                            name="bankName"
                            value={formData.bankName}
                            onChange={handleChange}
                            required
                            placeholder="Ej: Banco Santander"
                            style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #444', background: '#222', color: 'white' }}
                        />
                    </div>

                    <div className="form-group">
                        <label>Tipo de Cuenta</label>
                        <select
                            name="accountType"
                            value={formData.accountType}
                            onChange={handleChange}
                            style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #444', background: '#222', color: 'white' }}
                        >
                            <option value="corriente">Cuenta Corriente</option>
                            <option value="vista">Cuenta Vista / RUT</option>
                            <option value="ahorro">Cuenta de Ahorro</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Número de Cuenta</label>
                        <input
                            id="verify-account-number"
                            type="text"
                            name="accountNumber"
                            value={formData.accountNumber}
                            onChange={handleChange}
                            required
                            placeholder="Ej: 123456789"
                            style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #444', background: '#222', color: 'white' }}
                        />
                    </div>

                    <div className="form-group">
                        <label>RUT Titular</label>
                        <input
                            id="verify-rut"
                            type="text"
                            name="rut"
                            value={formData.rut}
                            onChange={handleChange}
                            required
                            placeholder="Ej: 12.345.678-9"
                            style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #444', background: '#222', color: 'white' }}
                        />
                    </div>

                    <div className="modal-actions" style={{ marginTop: '10px' }}>
                        <button type="submit" className="btn btn-primary" disabled={isLoading} style={{ width: '100%' }}>
                            {isLoading ? 'Guardando...' : 'Enviar para Verificación'}
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <BankVerificationSuccessModal 
            isOpen={showSuccessModal} 
            onClose={handleSuccessModalClose}
        />
        </>
    );
};

export default VerificationModal;
